import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { gridCellClass } from "./TireComparisonGrid";
import { selectPricingContext } from "./selectPricingContext";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
  partQuantity: CompareResults["partQuantity"];
};

export const Tax: FunctionComponent<ProductInfoProps> = ({
  part,
  partQuantity,
}) => {
  const { t } = useTranslation();
  const { taxPercent, taxTotal } = selectPricingContext(partQuantity);
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) ? (
        <>
          <PriceDisplay>{taxTotal}</PriceDisplay>{" "}
          <span className="font-thin text-ink-2">({Number(taxPercent)}%)</span>
        </>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
